import React from "react"
import RoomCardBody from "../../shared/RoomCardBody/RoomCardBody"
import RoomCardFooter from "../../shared/RoomCardFooter/RoomCardFooter"
import RoomCardHeader from "../../shared/RoomCardHeader/RoomCardHeader"
import Wrapper from "../../shared/Wrapper/Wrapper"

import "./Unclean.css"
import { useElapsedTime } from "src/shared/hooks/useElapsedTime"
import { useDate } from "src/shared/hooks/useDate"
import { RoomStatusProps } from "../../../../interfaces/RoomStatusProps.interface"
import { useTimePulse } from "src/shared/hooks/useTimePulse"
import { useDispatch } from "react-redux"
import { startGetSelectedRoom } from "src/pages/home/store/thunks/rooms.thunk"
import { selectSuciaInitialSection } from "src/store/roomDetails/suciaSlice"
import useIsColaboradorActive from "src/shared/hooks/useIsColaboradorActive"

const Unclean = ({
    roomTypeName,
    roomNumber,
    dateStatusChanged,
    hasIncidences,
    uncleanTimeLimit,
    room,
}: Omit<RoomStatusProps, "roomStatus">) => {
    const { UTCStringToLocalDate } = useDate()
    const [elaspedTime] = useElapsedTime(UTCStringToLocalDate(dateStatusChanged))

    const [now] = useTimePulse()
    const dispatch = useDispatch()
    const { InactiveModal, validateIsColabActive } = useIsColaboradorActive()

    return (
        <Wrapper bgColor="#FFE99C"
            alertBgColor1={now > (uncleanTimeLimit || now) ? "#fff4cf" : null}
            alertBgColor2={now > (uncleanTimeLimit || now) ? "#ffe99c" : null}
        >
            <RoomCardHeader
                hasIncidences={hasIncidences}
                iconBgColor="var(--sucia)"
                iconName="trashFilled"
                roomNumber={roomNumber}
                roomTypeName={roomTypeName}
            />
            <RoomCardBody verticalAlign="center">
                <span className="room-card--xl-unclean__gest-name">{elaspedTime}</span>
                <div className="room-card--xl-unclean__description-wrapper">
                    <span className="room-card--xl-unclean__gest-number">Tiempo sin limpiar</span>
                </div>
            </RoomCardBody>
            <RoomCardFooter
                text="Limpiar habitación"
                bgColor={"var(--white-transparent)"}
                onSliderTriggered={validateIsColabActive(() => {
                    dispatch(
                        startGetSelectedRoom(room?.habitacion_id, false, () => {
                            dispatch(selectSuciaInitialSection("clean-staff"))
                        })
                    )
                })}
            />
            {InactiveModal}
        </Wrapper>
    )
}

export default Unclean
